const CATEGORY_DEFAULTS = {
  спецодежда: 6,
  инвентарь: 12,
  оборудование: 24,
  техника: 36,
};

/**
 * Returns default amortization period in months for a given category name.
 */
export function getAmortizationDefault(categoryName) {
  if (!categoryName) return null;
  const normalized = String(categoryName).trim().toLowerCase();
  return CATEGORY_DEFAULTS[normalized] ?? null;
}
